import { useState } from 'react';
import { getProfileCompletion } from 'pages/Profile/helper';
import Insurance from './Insurance';
import ProfileModal from './ProfileModal';
import SectionCard from './SectionCard';
import { getProfileCards, getProfileSections } from './helper';

const Profile = ({ profile, onRefresh }) => {
  const [stepId, setStepId] = useState(null);
  const sections = getProfileSections(profile);
  const completion = getProfileCompletion(profile?.attributes);
  const [personal, medical] = getProfileCards(sections, completion);

  const closeModal = () => {
    setStepId(null);
    onRefresh();
  };

  return (
    <>
      <SectionCard {...personal} onView={() => setStepId('personal')} />

      <Insurance insurance={sections.insurance} completed={completion.insurance} onView={() => setStepId('insurance')} />

      <SectionCard {...medical} onView={() => setStepId('medical')} />

      <ProfileModal
        stepId={stepId}
        data={sections[stepId]}
        practice={sections.practice}
        completed={completion[stepId]}
        onClose={closeModal}
      />
    </>
  );
};

export default Profile;
